import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusMagic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusMagic"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M13.1667 9.41667L14 7.75L14.8333 9.41667L16.5 10.25L14.8333 11.0833L14 12.75L13.1667 11.0833L11.5 10.25L13.1667 9.41667ZM8.83333 14.0833L9.5 12.75L10.1667 14.0833L11.5 14.75L10.1667 15.4167L9.5 16.75L8.83333 15.4167L7.5 14.75L8.83333 14.0833Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusMagic;
